module.exports = __webpack_public_path__ + "static/img/1008_big.da5cc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1008_big.png
// module id = qnmn
// module chunks = 1